import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import OrderSellerList from "./components/OrderSellerList";
// import SellerSales from "@/pages/(MarketPlace)/sales/page";

// const tabOptions = [
//   { label: "Quotations", value: "quotation" },
//   { label: "Marketplace Sales", value: "marketplace" },
// ];

const SellerOrder = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Get tab from query param
  const params = new URLSearchParams(location.search);
  // const salesTab = params.get("sales") || "quotation";
  // const tabIndex = tabOptions.findIndex((t) => t.value === salesTab);

  // // On tab change, update query param
  // const handleTabChange = (_: any, newValue: number) => {
  //   const newTab = tabOptions[newValue].value;
  //   params.set("sales", newTab);
  //   navigate({ search: params.toString() }, { replace: true });
  // };

  // If no tab in URL, set default
  useEffect(() => {
    if (!params.get("sales")) {
      params.set("sales", "quotation");
      navigate({ search: params.toString() }, { replace: true });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#f8fafa !important" }}
    >
      <Box
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          borderBottom: 1,
          borderColor: "divider",
          mb: 2,
        }}
      >
        {/* <Tabs
          value={tabIndex === -1 ? 0 : tabIndex}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
        >
          {tabOptions.map((tab) => (
            <Tab key={tab.value} label={tab.label} />
          ))}
        </Tabs> */}
      </Box>
      <div className="flex-1">
        <OrderSellerList />
        {/* {salesTab === "marketplace" ? <SellerSales /> : <OrderSellerList />} */}
      </div>
    </div>
  );
};

export default SellerOrder;
